/* tslint:disable */
/* eslint-disable */
// codeclimate disable
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { generateClient } from 'aws-amplify/api';
import { Observable } from "zen-observable-ts";
const client = generateClient();

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type __SubscriptionContainer = {
  onChangeNotification: OnChangeNotificationSubscription;
};

export type CreateNotificationInput = {
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

export type Notification = {
  __typename: "Notification";
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

export type ModelNotificationConditionInput = {
  and?: Array<ModelNotificationConditionInput | null> | null;
  createdAt?: ModelStringInput | null;
  message?: ModelStringInput | null;
  not?: ModelNotificationConditionInput | null;
  or?: Array<ModelNotificationConditionInput | null> | null;
  readStatus?: ModelStringInput | null;
  uri?: ModelStringInput | null;
};

export type ModelStringInput = {
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  beginsWith?: string | null;
  between?: Array<string | null> | null;
  contains?: string | null;
  eq?: string | null;
  ge?: string | null;
  gt?: string | null;
  le?: string | null;
  lt?: string | null;
  ne?: string | null;
  notContains?: string | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet"
}

export type ModelSizeInput = {
  between?: Array<number | null> | null;
  eq?: number | null;
  ge?: number | null;
  gt?: number | null;
  le?: number | null;
  lt?: number | null;
  ne?: number | null;
};

export type DeleteNotificationInput = {
  id?: string | null;
};

export type UpdateNotificationInput = {
  id: string;
  readStatus?: string | null;
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection";
  items?: Array<Notification | null> | null;
  nextToken?: string | null;
  scannedCount?: number | null;
};

export type ModelNotificationFilterInput = {
  and?: Array<ModelNotificationFilterInput | null> | null;
  cognitoId?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  id?: ModelIDInput | null;
  message?: ModelStringInput | null;
  not?: ModelNotificationFilterInput | null;
  or?: Array<ModelNotificationFilterInput | null> | null;
  readStatus?: ModelStringInput | null;
  uri?: ModelStringInput | null;
};

export type ModelIDInput = {
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  beginsWith?: string | null;
  between?: Array<string | null> | null;
  contains?: string | null;
  eq?: string | null;
  ge?: string | null;
  gt?: string | null;
  le?: string | null;
  lt?: string | null;
  ne?: string | null;
  notContains?: string | null;
  size?: ModelSizeInput | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type AddNotificationMutation = {
  __typename: "Notification";
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

export type DeleteNotificationMutation = {
  __typename: "Notification";
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

export type UpdateNotificationMutation = {
  __typename: "Notification";
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

export type CountByReadStatusQuery = {
  __typename: "ModelNotificationConnection";
  items?: Array<{
    __typename: "Notification";
    cognitoId: string;
    createdAt: string;
    id: string;
    message: string;
    readStatus: string;
    uri?: string | null;
  } | null> | null;
  nextToken?: string | null;
  scannedCount?: number | null;
};

export type GetNotificationQuery = {
  __typename: "Notification";
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

export type ListNotificationsQuery = {
  __typename: "ModelNotificationConnection";
  items?: Array<{
    __typename: "Notification";
    cognitoId: string;
    createdAt: string;
    id: string;
    message: string;
    readStatus: string;
    uri?: string | null;
  } | null> | null;
  nextToken?: string | null;
  scannedCount?: number | null;
};

export type OnChangeNotificationSubscription = {
  __typename: "Notification";
  cognitoId: string;
  createdAt: string;
  id: string;
  message: string;
  readStatus: string;
  uri?: string | null;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async AddNotification(
    input: CreateNotificationInput
  ): Promise<AddNotificationMutation> {
    const statement = `mutation AddNotification($input: CreateNotificationInput!) {
        addNotification(input: $input) {
          __typename
          cognitoId
          createdAt
          id
          message
          readStatus
          uri
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <AddNotificationMutation>response.data.addNotification;
  }
  async DeleteNotification(
    input: DeleteNotificationInput,
    condition?: ModelNotificationConditionInput
  ): Promise<DeleteNotificationMutation> {
    const statement = `mutation DeleteNotification($condition: ModelNotificationConditionInput, $input: DeleteNotificationInput!) {
        deleteNotification(condition: $condition, input: $input) {
          __typename
          cognitoId
          createdAt
          id
          message
          readStatus
          uri
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNotificationMutation>response.data.deleteNotification;
  }
  async UpdateNotification(
    input: UpdateNotificationInput,
    condition?: ModelNotificationConditionInput
  ): Promise<UpdateNotificationMutation> {
    const statement = `mutation UpdateNotification($condition: ModelNotificationConditionInput, $input: UpdateNotificationInput!) {
        updateNotification(condition: $condition, input: $input) {
          __typename
          cognitoId
          createdAt
          id
          message
          readStatus
          uri
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNotificationMutation>response.data.updateNotification;
  }
  async CountByReadStatus(
    readStatus?: string
  ): Promise<CountByReadStatusQuery> {
    const statement = `query CountByReadStatus($readStatus: String) {
        countByReadStatus(readStatus: $readStatus) {
          __typename
          items {
            __typename
            cognitoId
            createdAt
            id
            message
            readStatus
            uri
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (readStatus) {
      gqlAPIServiceArguments.readStatus = readStatus;
    }
    const response = (await client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CountByReadStatusQuery>response.data.countByReadStatus;
  }
  async GetNotification(id: string): Promise<GetNotificationQuery> {
    const statement = `query GetNotification($id: ID!) {
        getNotification(id: $id) {
          __typename
          cognitoId
          createdAt
          id
          message
          readStatus
          uri
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNotificationQuery>response.data.getNotification;
  }
  async ListNotifications(
    filter?: ModelNotificationFilterInput,
    limit?: number,
    nextToken?: string,
    query?: ModelNotificationFilterInput,
    sortDirection?: ModelSortDirection
  ): Promise<ListNotificationsQuery> {
    const statement = `query ListNotifications($filter: ModelNotificationFilterInput, $limit: Int, $nextToken: String, $query: ModelNotificationFilterInput, $sortDirection: ModelSortDirection) {
        listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken, query: $query, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            cognitoId
            createdAt
            id
            message
            readStatus
            uri
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (query) {
      gqlAPIServiceArguments.query = query;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNotificationsQuery>response.data.listNotifications;
  }
  OnChangeNotificationListener(
    cognitoId: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onChangeNotification">>
  > {
    const statement = `subscription OnChangeNotification($cognitoId: String!) {
        onChangeNotification(cognitoId: $cognitoId) {
          __typename
          cognitoId
          createdAt
          id
          message
          readStatus
          uri
        }
      }`;
    const gqlAPIServiceArguments: any = {
      cognitoId
    };
    return client.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as unknown as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onChangeNotification">
      >
    >;
  }
}
